import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@lightspeed/flame/Core';
import { IconCheckmark } from '@lightspeed/flame/Icon/Checkmark';
import { Text } from '@lightspeed/flame/Text';

import { CustomerCFDStatus } from '..';

interface Props {
  isSaved: boolean;
}

const ScreenSave: React.FC<Props> = ({ isSaved }) => {
  const { t } = useTranslation();
  const isCustomerSave = window.location.search.includes(CustomerCFDStatus.SAVE) || isSaved;

  return isCustomerSave ? (
    <Box textAlign="center">
      <IconCheckmark size="6rem" color="green-500" />
      <br />
      <Text mt={4} color="white" size="large">
        {t('hub.cfd.registerCustomer.save')}
      </Text>
    </Box>
  ) : null;
};

export default ScreenSave;
